import { render, staticRenderFns } from "./GameStatus.vue?vue&type=template&id=f2f78cf6"
import script from "./GameStatus.vue?vue&type=script&lang=js"
export * from "./GameStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports